<div class="container"><br>
  <div class="form-group">
    <label>{{question.question_copy}}</label>
    <input type="tel"
           (change)="calculate()"
           placeholder="# of weeks"
           [class]="'form-control week answers ' + question.cent_aq_question_id"
           [id]="question.cent_aq_question_id">
  </div>
  <div class="form-group">
    <input currencyMask [options]="maskOptions" type="tel" id="amount" value=""
           (change)="calculate()"
           [class]="'form-control amount answers ' + question.cent_aq_question_id"
           [placeholder]="'R Amount/Week (Limit ' +
           (currentVap.value_min | currency : 'ZAR' : 'R':'1.0-0') + ' - ' +
           (currentVap.value_max | currency : 'ZAR' : 'R':'1.0-0') + ')'">
  </div>
</div>
